"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Grid = exports.truncateText = void 0;
var react_1 = __importDefault(require("react"));
var underscore_string_1 = require("underscore.string");
var OutsideWrapper_1 = require("./OutsideWrapper");
exports.truncateText = function (str, replaceStr) {
    if (replaceStr) {
        return str
            .replace("." + replaceStr, "")
            .slice(0, 13)
            .concat("." + replaceStr);
    }
    return str.slice(0, 13);
};
exports.Grid = function (props) {
    var _a = props.grid, grid = _a === void 0 ? 5 : _a, _b = props.type, type = _b === void 0 ? "checkbox" : _b, items = props.items, onSelect = props.onSelect, onDoubleClick = props.onDoubleClick, _c = props.style, style = _c === void 0 ? {} : _c, _d = props.hasDetails, hasDetails = _d === void 0 ? false : _d, onHover = props.onHover, hoverItem = props.hoverItem, 
    // contextMenu,
    itemOpenMenu = props.itemOpenMenu
    // onItemOpenMenu,
    ;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "grid o-scroll", "data-grid": grid, style: __assign(__assign({}, style), { padding: (items === null || items === void 0 ? void 0 : items.length) ? "2em" : "0" }) }, items === null || items === void 0 ? void 0 : items.map(function (i) {
            var _a, _b, _c, _d, _e, _f;
            return (react_1.default.createElement("div", { className: "grid-item " + (itemOpenMenu === i._id ? "show-menu" : ""), key: i._id },
                react_1.default.createElement(OutsideWrapper_1.OutsideDetectorWrapper
                // outsideClick={() => (contextMenu && itemOpenMenu === i._id) && (onItemOpenMenu && onItemOpenMenu(''))}>
                , { 
                    // outsideClick={() => (contextMenu && itemOpenMenu === i._id) && (onItemOpenMenu && onItemOpenMenu(''))}>
                    outsideClick: function () { return false; } },
                    react_1.default.createElement("label", { className: "checkbox-container", onDoubleClick: function () { return onDoubleClick && onDoubleClick(i); } },
                        react_1.default.createElement("input", { type: type, name: "grid", checked: i === null || i === void 0 ? void 0 : i.checked, className: "checkbox", onChange: onSelect(i) }),
                        react_1.default.createElement("div", { className: "checkbox-item", 
                            // onMouseEnter={() => !(contextMenu && itemOpenMenu === i._id) && (onHover && onHover(i._id))}
                            onMouseEnter: function () { return onHover && onHover(i._id); }, onMouseLeave: function () { return onHover && onHover(""); } },
                            hoverItem,
                            ((_a = i.designTemplateFields) === null || _a === void 0 ? void 0 : _a.length) > 0 ? (react_1.default.createElement("span", { className: "position-absolute grid-item-icon", style: {
                                    bottom: "-0.25em",
                                    right: "0",
                                    backgroundColor: "#fa3fb8",
                                    height: "2em",
                                    width: "2em",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    borderRadius: "10%"
                                } },
                                react_1.default.createElement("i", { className: "fas fa-check-circle", style: { color: "white" } }))) : null,
                            react_1.default.createElement("img", { src: i === null || i === void 0 ? void 0 : i.itemImgUrl, alt: exports.truncateText((_b = i === null || i === void 0 ? void 0 : i.itemName) !== null && _b !== void 0 ? _b : "", i === null || i === void 0 ? void 0 : i.itemFileExt) }))),
                    react_1.default.createElement("p", { className: "text-center grid-item-name", title: i === null || i === void 0 ? void 0 : i.itemName }, exports.truncateText((_e = (_c = i === null || i === void 0 ? void 0 : i.itemName) === null || _c === void 0 ? void 0 : _c.replace("." + ((_d = i === null || i === void 0 ? void 0 : i.itemFileExt) !== null && _d !== void 0 ? _d : ""), "")) !== null && _e !== void 0 ? _e : "", "")),
                    hasDetails && (react_1.default.createElement("div", { className: "grid-item-detail" },
                        react_1.default.createElement("button", { type: "button", className: "grid-item-detail-toggle", "data-toggle": "dropdown", "aria-expanded": "false" },
                            "Product Detail ",
                            react_1.default.createElement("i", { className: "fas fa-angle-down" })),
                        react_1.default.createElement("div", { className: "dropdown-menu rounded shadow-sm px-3" }, (_f = i === null || i === void 0 ? void 0 : i.productAttributes) === null || _f === void 0 ? void 0 : _f.map(function (attr, idx) {
                            var _a, _b;
                            return (react_1.default.createElement("div", { key: idx, className: "mb-1" },
                                underscore_string_1.humanize(attr === null || attr === void 0 ? void 0 : attr.attribute),
                                ": ", (_b = (_a = attr === null || attr === void 0 ? void 0 : attr.value) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : ""));
                        })))))));
        })),
        props.children));
};
